import * as React from "react";
import { Link } from "react-router-dom";
import LayoutSinNavegacion from "../../components/Layout/LayoutSinNavegacion";

class SesionDesconectada extends React.Component {
  render() {
    return (
      <LayoutSinNavegacion>
        <h1 className="h1 text-gray-900 mt-4">Sesión Desconectada</h1>
        <p className="lead text-gray-800">
          La sesión del usuario se ha cerrado.
        </p>
        <Link to="/">
          <button className="btn btn-primary btn-icon-split text-center">
            <span className="icon text-white-50">
              <i className="fas fa-arrow-alt-circle-left"></i>
            </span>
            <span className="text">Volver a Ingresar</span>
          </button>
        </Link>
      </LayoutSinNavegacion>
    );
  }
}

export default SesionDesconectada;
